import {csrf} from "~/lib/tools";

const baseUrl = (org_id, machine_id, id)  => `/dashboard/organizations/${org_id}/fleet/${machine_id}/machine_sensors${id ? '/' + id.toString() :  ''}.json`;
const fetchSensors = async (org_id, machine_id) => {
    return fetch(baseUrl(org_id, machine_id))
        .then(r => r.json());
}
const upsertSensor = async (org_id, machine_id, payload) => {
    let url = payload.id ? baseUrl(org_id, machine_id, payload.id) : baseUrl(org_id, machine_id);
    let method = payload.id ? 'PUT' : 'POST';
    return await fetch(
        url,
        {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": csrf()
            },
            body: JSON.stringify(payload),
        })
        .then(r => r.json());
}

const deleteSensor = async (org_id, machine_id, id) => {
    return await fetch(
        baseUrl(org_id, machine_id, id),
        {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": csrf()
            }
        })
        .then(r => r.json());
}


export {fetchSensors, upsertSensor, deleteSensor}